// helpers (put these above the component return, inside the component file)
const typeToLabel = {
  reference: "Reference No",
  policy: "Policy No",
  request: "Request No",
  survey: "Survey No",
}

export const getTypeLabelForTicket = ticketData => {
  if (ticketData?.refNo) return "Reference No"
  if (ticketData?.projectNo?.type) {
    return typeToLabel[ticketData.projectNo.type] || "Project No"
  }
  return "N/A"
}

export const numberValueForTicket = ticketData => {
  if (ticketData?.refNo) return ticketData.refNo
  if (ticketData?.projectNo?.value) return ticketData.projectNo.value
  return "N/A"
}
